import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { DollarSign, Receipt } from "lucide-react";
import { Collection } from "../../pages/Collection";

interface AllPaymentsProps {
  collections: Collection[];
}

const AllPayments = ({ collections }: AllPaymentsProps) => {
  return (
    <div className="space-y-4">
      {/* <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-2">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Collections Today</CardTitle>
            <DollarSign className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">$717.50</div>
            <p className="text-xs text-muted-foreground">+5.2% from yesterday</p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Transactions Today</CardTitle>
            <Receipt className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">3</div>
            <p className="text-xs text-muted-foreground">+1 from yesterday</p>
          </CardContent>
        </Card>
      </div> */}
    </div>
  );
};

export default AllPayments;
